export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11909.b6ad2863.jpg";